import { FormTextInput } from '@laxmimanogna/code-quick-components';
import React, { useRef, useState } from 'react';
import { EditIcon, PersonIcon } from '../../../constants/IconData';

const EDIT_TEXT_FIELD = 'EDIT_INPUT';
const SHOW = 'DISABLE_INPUT';
function FormInputField(props) {
  const ref = useRef(null);
  const [mode, setMode] = useState(SHOW);
  let editInput = async () => {
    await setMode(EDIT_TEXT_FIELD);
    ref.current.focus();
  };
  return (
    <>
      <FormTextInput
        ref={ref}
        name={props.name}
        control={props.control}
        id={props.id}
        style={{ opacity: '1' }}
        disabled={mode === SHOW}
        rightIcon={
          <EditIcon
            id={`edit-icon-first_name`}
            onClick={() => {
              editInput();
            }}
            style={{ cursor: 'pointer' }}
          />
        }
        leftIcon={<PersonIcon />}
        size="md"
        {...props}
      />
    </>
  );
}

export default FormInputField;
